import {createElement as h, Fragment} from "react";

export const fragments = (...args) => h(Fragment, {},
    ...args,
);

export const fragments2 = (elements) => h(Fragment, {},
    ...elements,
);
